import { PageView } from '@/components/layouts'
import InvoiceMailing from '@/views/others-inquiry/invoice-mailing'
import CustomerEscrowSugar from '@/views/others-inquiry/customer-escrow-sugar'
export default {
  path: '/others-inquiry',
  name: 'others-inquiry',
  component: PageView,
  meta: { title: '其他查询', keepAlive: false, icon: 'iconfont qitachaxun' },
  children: [
    {
      path: '/others-inquiry/invoice-mailing',
      name: '/others-inquiry/invoice-mailing',
      component: InvoiceMailing,
      meta: { title: '发票邮寄查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    },
    {
      path: '/others-inquiry/customer-escrow-sugar',
      name: '/others-inquiry/customer-escrow-sugar',
      component: CustomerEscrowSugar,
      meta: { title: '客户代管糖查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    }
  ]
}
